import "./ResourceSpaceBooking.css"
import { Checkbox, CheckboxOnChangeData, Dropdown, Input, InputProps, makeStyles, OptionOnSelectData, SelectionEvents, useId, Option, Text, Textarea, Avatar, Button, Popover, PopoverTrigger, PopoverSurface, TextareaOnChangeData } from "@fluentui/react-components";
import { DatePickerProps } from "antd";
import moment from "moment";
import dayjs from 'dayjs';
import { ChangeEvent, useEffect, useState } from "react";
import { IoMdAddCircleOutline } from "react-icons/io";
import { getSettings } from "../../viewmodel/getsettings";
import { RecurringOption } from './ResourceSpaceTypeModel';
import { User } from "../../APIService/SearchService";
import { CommonInfo } from "../../CommonData/Config";
import CurrentBookingUser from "./CurrentBookingUser";
import ResourceModel from "./ResourceModel";
import { BookOption, SelectedResourceObject } from "../../APIService/UserBookingService";
import RXTimePicker from "../TimePicker/RXTimePicker";

import RXDatePicker from "../DatePicker/RXDatePicker";
import { t } from "../../utils/language";

type ResourceSpaceBookingProps = {
    theme: string;
    selectedDate: Date;
    addedResources: SelectedResourceObject[];
    onDateChange: (date: Date) => void;
    onBookingTitleChange: (text: string) => void;
    isPrivateToggle: (ev: React.ChangeEvent<HTMLInputElement>, data: CheckboxOnChangeData) => void;
    isPrivate: boolean;
    onCloseModel: () => void;
    onSaveAction: () => void;
    removeResource: (index: number) => void;
    addAttendeeClick: () => void;
    currentUser: User;
    usersList: User[];
    addedUsersList: User[];
    showUserDropdown: boolean;
    onAddAttendee: (user: User) => void;
    onRemoveAttendee: (user: User) => void;
    userSearchText: string;
    userSearchTextChange: (text: string) => void;
    recurringOptions: RecurringOption[];
    selectedRecurringOption: RecurringOption | null;
    reccuringOptionSelect: (event: SelectionEvents, data: OptionOnSelectData) => void;
    reccuringEndDate: Date | null;
    onReccuringDateChange: (date: Date) => void;
    bookOptions: BookOption[];
    bookOptionsChange: (event: SelectionEvents, data: OptionOnSelectData) => void;
    selectedBookOption: BookOption;
    bookStartTime: Date;
    bookEndTime: Date;
    bookingInfoText: string;
    bookingInfoChange: (ev: ChangeEvent<HTMLTextAreaElement>, data: TextareaOnChangeData) => void;
    onStartTimeChange: (date: Date) => void;
    onEndTimeChange: (date: Date) => void;
    showNoteView: boolean;
    onLaunchNoteClick: () => void;
    timeInterval: number;
    onConflictClick: (index: number) => void;
    conflictViewShown: boolean;
}

const useStyles = makeStyles({
    container: {
        display: "flex",
        flexDirection: "column",
        height: "100%",
        position: "relative",
        overflow: "hidden",
        // borderRight: "1px solid #525252"
    },
    scrollContainer: {
        flex: 1,
        overflowX: "hidden",
        overflowY: "auto"
    },
    actionContainer: {
        position: "sticky",
        bottom: 0,
        height: "60px",
        flexShrink: 0,
        padding: "15px",
        gap: "10px",
        display: "flex",
        alignItems: "center",
        justifyContent: "flex-end",
    },
    bookingTitleView: {
        height: "50px",
        padding: "10px 20px 0px 20px",
        gap: "4px",
    },
    bookingTitle: {
        width: "335px",
        height: "40px",
        padding: "5px 10px",
        gap: "10px",
        fontSize: "16px",
        fontWeight: 400,
        lineHeight: "30px",
        letterSpacing: "0px"
    },
    privateContainer: {
        height: "46px",
        padding: "8px 10px",
        gap: "10px",
        alignItems: "center",
        flexDirection: "row",
        justifyContent: "center",
        // marginBottom: "10px"
    },
    formIcon: {
        width: "30px",
        height: "30px",
        padding: "2px",
        // backgroundColor: "blue"
    },
    indicator: {
        border: "none",
        backgroundColor: "transparent",
        padding: 0,
        boxShadow: "none",

        // removes focus ring on indicator
        ":focus-within": {
            outline: "none",
            boxShadow: "none",
        },
    },
    dropDownContainer: {
        display: "flex",
        // alignItems: "center",
        padding: "10px",
        gap: "10px"
    },
    timePickerContainer: {
        display: "flex",
        flex: 1,
        flexDirection: "row",
        marginTop: "10px",
        width: "100%",
        height: "30px"
    },

    timePicker: {
        flex: 1,
        minWidth: 0,
        height: "30px"
    },
    separator: {
        width: "24px",
        height: "30px",
        display: "flex",
        alignItems: "center",
        justifyContent: "center"
    },
    endDateLabel: {
        width: "70px",
        height: "20px",
        fontSize: "14px",
        lineHeight: "20px",
        flexWrap: "nowrap"
    },
    recurringContainer: {
        display: "flex",
        minHeight: "50px",
        padding: "10px",
        gap: "10px"
    },
    textAreaContainer: {
        display: "flex",
        height: "85px",
        padding: "10px",
        gap: "10px",
        position: "relative"
    },
    textBox: {
        width: "315px",
        borderRadius: "3px",
        backgroundColor: "#1111"
    },
    launchNoteButton: {
        width: "30px",
        height: "30px",
        position: "absolute",
        bottom: "11px",
        right: "11px",
        zIndex: 10,
        border: 0
    },
    profileContainer: {
        display: "flex",
        width: "100%",
        alignItems: "center",
        padding: "3px 10px",
        gap: "10px"
    },
    extendableContainer: {
        display: "flex",
        gap: "10px",
        marginTop: "10px"
    },
    extendListConatiner: {
        width: "315px"
    },
    addAttendeeContainer: {
        width: "315px",
        height: "35px",
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
        justifyContent: "space-between",
        padding: "15px"
    },
    resourceContainer: {
        display: "flex",
        flexDirection: "row",
        width: "315px",
        padding: "12px 10px",
        gap: "5px"
    },
    resourceIcon: {
        width: "38px",
        height: "38px",
        padding: "2px"
    }
});

const ResourceSpaceBooking = ({
    theme,
    selectedDate,
    onDateChange,
    addedResources,
    onBookingTitleChange,
    isPrivate,
    isPrivateToggle,
    onCloseModel,
    removeResource,
    addAttendeeClick,
    currentUser,
    userSearchText,
    userSearchTextChange,
    usersList,
    addedUsersList,
    showUserDropdown,
    onAddAttendee,
    recurringOptions,
    selectedRecurringOption,
    reccuringOptionSelect,
    reccuringEndDate,
    onReccuringDateChange,
    bookOptions,
    bookOptionsChange,
    selectedBookOption,
    bookStartTime,
    bookEndTime,
    onSaveAction,
    onRemoveAttendee,
    bookingInfoText,
    bookingInfoChange,
    onStartTimeChange,
    onEndTimeChange,
    showNoteView,
    onLaunchNoteClick,
    timeInterval,
    onConflictClick,
    conflictViewShown
}: ResourceSpaceBookingProps) => {
    const styles = useStyles();
    const getSettingsData = getSettings;

    const [showUserSelect, setShowUserSelect] = useState<boolean>(false);

    const filteredUsers = usersList.filter(user => {
        const notAlreadyAdded = !addedUsersList.some(
            added => added.Id === user.Id
        );

        const matchesSearch =
            !userSearchText ||
            user.FirstName.toLowerCase().includes(userSearchText.toLowerCase()) ||
            user.EmailAddress.toLowerCase().includes(userSearchText.toLowerCase());

        return notAlreadyAdded && matchesSearch;
    });

    const dropdownId = useId("dropdown-default");

    useEffect(() => {
        setShowUserSelect(showUserDropdown);
    }, [showUserDropdown]);

    const onClickClose = () => {
        onCloseModel();
    };

    const onChangeTitle: InputProps["onChange"] = (ev, data) => {
        onBookingTitleChange(data.value);
    }

    const onChangeUserSearch: InputProps["onChange"] = (ev, data) => {
        userSearchTextChange(data.value);
    }

    const isDayDisabled = (date: any) => {
        const workingDays = getSettingsData.MysettingsBasicdata[0]?.WorkingDays || {};
        const dayOfWeek = dayjs(date).format('dddd');
        return workingDays[dayOfWeek] === false;
    };

    const handleDateSelect: DatePickerProps['onChange'] = async (date: any, dateString: any) => {
        const newDate = moment(date.$d).startOf('day');
        onDateChange(newDate.toDate());
    }

    const handleReccuringDateSelect: DatePickerProps['onChange'] = async (date: any, dateString: any) => {
        const newDate = moment(date.$d).startOf('day');
        onReccuringDateChange(newDate.toDate());
    }

    const onAddWorkspacesAction = () => {
        console.log("Add Workspaces Clicked");
    };

    return (
        <div className={styles.container} style={{ backgroundColor: theme === "light" ? "#ffffff" : "#1A1A1A" }}>
            <div className={styles.scrollContainer}>
                <div className={styles.bookingTitleView} style={{}}>
                    <Input
                        size="large"
                        appearance="underline"
                        placeholder={`${t('AddTitle')}`}
                        className={styles.bookingTitle}
                        onChange={onChangeTitle}
                    />
                </div>
                <div className={styles.privateContainer}>
                    <img src={`${CommonInfo.folderName}${theme === 'dark' ? '/Locklight.svg' : '/lock.svg'}`} className={styles.formIcon} />
                    <Checkbox
                        label={
                            <span style={{ fontSize: "14px", fontWeight: 400, letterSpacing: "0px", alignSelf: "center" }}>{t('Private')}</span>
                        }
                        onChange={isPrivateToggle}
                        checked={isPrivate}
                        indicator={{
                            className: styles.indicator,
                            children: (
                                <img
                                    src={`${CommonInfo.folderName}${isPrivate ? theme === "dark" ? "/checkbox/checked/dark.svg" : "/checkbox/checked/light.svg" : theme === "dark" ? "/checkbox/unchecked/dark.svg" : "/checkbox/unchecked/light.svg"}`}
                                    alt=""
                                    style={{ width: 24, height: 24, padding: 2 }}
                                />
                            ),
                        }}
                    />
                </div>
                <div
                    style={{ display: "flex", flexDirection: "row", alignItems: "center" , height: 50, padding: 10, gap: 10 }}
                >
                    <img src={`${CommonInfo.folderName}${theme === 'dark' ? '/datefield/light.svg' : '/datefield/dark.svg'}`} className={styles.formIcon} />
                    <div style={{width: 315, height: 30, padding: "3px", borderRadius: "4px", border: theme === "dark" ? "1px solid #525252" : "1px solid #EAEFF5"}}>
                        <RXDatePicker 
                            theme={theme}
                            date={selectedDate} 
                            handleDateSelect={handleDateSelect} 
                            minDate={new Date()}
                            isDateDisabled={isDayDisabled}
                        />
                    </div>
                </div>
                <div className={styles.dropDownContainer}>
                    <img src={`${CommonInfo.folderName}${theme === 'dark' ? '/clocklight.svg' : '/clock.svg'}`} className={styles.formIcon} />
                    <div style={{ width: "100%" }}>
                        <Dropdown 
                            id={dropdownId} 
                            value={selectedBookOption.name} 
                            selectedOptions={[selectedBookOption.name]} 
                            onOptionSelect={bookOptionsChange}
                        >
                            {bookOptions.map((option) => (
                                <Option key={option.id} value={option.name}>{option.name}</Option>
                            ))}
                        </Dropdown>
                        <div className={styles.timePickerContainer}>
                            <div className={styles.timePicker}>
                                <RXTimePicker 
                                    theme={theme} 
                                    value={moment(bookStartTime).format("HH:mm")}
                                    bookingDate={selectedDate}
                                    defaultTime={bookStartTime}
                                    onTimeChange={onStartTimeChange} 
                                    timeInterval={timeInterval}
                                    // isDisabled={ selectedBookOption.id !== 0 ? true : false }
                                    isDisabled={ false }
                                />
                            </div>
                            <div className={styles.separator}>-</div>
                            <div className={styles.timePicker}>
                                <RXTimePicker 
                                    theme={theme} 
                                    value={moment(bookEndTime).format("HH:mm")} 
                                    bookingDate={selectedDate}
                                    defaultTime={bookEndTime}
                                    onTimeChange={onEndTimeChange} 
                                    timeInterval={timeInterval}
                                    // isDisabled={ selectedBookOption.id !== 0 ? true : false }
                                    isDisabled={ false }
                                />
                            </div>
                        </div>
                    </div>
                </div>
                <div className={styles.recurringContainer}>
                    <img src={`${CommonInfo.folderName}${theme === 'dark' ? '/reccuring/light.svg' : '/reccuring/dark.svg'}`} className={styles.formIcon} />
                    <div style={{ flex: 1, gap: "10px" }}>
                        <Dropdown
                            id={dropdownId}
                            defaultValue="Make recurring"
                            onOptionSelect={reccuringOptionSelect}
                            style={{ width: "100%" }}
                        >
                            {recurringOptions.map((option) => (
                                <Option key={option.label}>{option.label}</Option>
                            ))}
                        </Dropdown>
                        {selectedRecurringOption && selectedRecurringOption.label !== "Never" && (
                            <div style={{ display: "flex", flexDirection: "row", marginTop: "10px", height: "30px", alignItems: "center" }}>
                                <Text className={styles.endDateLabel}>{t('EndDate')}</Text>

                                <div style={{flex: 1, paddingRight: 5, width: 215, height: 30, padding: "3px", borderRadius: "4px", border: theme === "dark" ? "1px solid #525252" : "1px solid #EAEFF5"}}>
                                    <RXDatePicker 
                                        theme={theme}
                                        date={reccuringEndDate ? reccuringEndDate : new Date()} 
                                        handleDateSelect={handleReccuringDateSelect} 
                                        minDate={new Date()}
                                        isDateDisabled={isDayDisabled}
                                    />
                                </div>
                            </div>
                        )}

                    </div>
                </div>
                <div className={styles.textAreaContainer}>
                    <img src={`${CommonInfo.folderName}${theme === 'dark' ? '/note/light.svg' : '/note/dark.svg'}`} className={styles.formIcon} />
                    <div className={styles.textBox}>
                        <Textarea style={{ width: "315px", height: "65px" }} placeholder="Booking info..." value={bookingInfoText} onChange={bookingInfoChange} />
                    </div>
                    <Button 
                        icon={<img src={`${CommonInfo.folderName}${theme === 'dark' ? '/launchNote/light.svg' : '/launchNote/dark.svg'}`} />} 
                        className={styles.launchNoteButton} 
                        onClick={onLaunchNoteClick}
                    />
                </div>
                <div className={styles.profileContainer}>
                    <img src={`${CommonInfo.folderName}${theme === 'dark' ? '/organiser/light.svg' : '/organiser/dark.svg'}`} className={styles.formIcon} />
                    {currentUser && (
                        <CurrentBookingUser
                            theme={theme}
                            userName={`${currentUser.FirstName} ${currentUser.LastName}(you)`}
                            userImage={currentUser.UserImage}
                            worklocationIcon={currentUser.WorkPlace ? currentUser.WorkPlace.IconPath : ""}
                            isOrganiser={true}
                            onClose={() => { console.log("Organiser Close Button Tapped") }}
                        />
                    )}
                </div>
                <div className={styles.extendableContainer} style={{ padding: "3px 10px" }}>
                    <img src={`${CommonInfo.folderName}${theme === 'dark' ? '/people/light.svg' : '/people/dark.svg'}`} className={styles.formIcon} />
                    <div className={styles.extendListConatiner}>
                        {addedUsersList.map((user, index) => (
                            <CurrentBookingUser
                                theme={theme}
                                userName={`${user.FirstName} ${user.LastName}`}
                                userImage={user.UserImage}
                                worklocationIcon={user.WorkPlace ? user.WorkPlace.IconPath : ""}
                                onClose={() => onRemoveAttendee(user)}
                            />
                        ))}

                        <>
                            <Popover open={showUserSelect} positioning="below-start" onOpenChange={(e, data) => {
                                console.log("User Select open: ", data.open)
                                 setShowUserSelect(data.open)
                                }}>
                                <PopoverTrigger>
                                    <div className={styles.addAttendeeContainer} onClick={addAttendeeClick}>
                                        <span style={{ fontSize: 13, fontWeight: 400, fontStyle: "normal" }}>{t('AddAttendee')}</span>
                                        <IoMdAddCircleOutline size={18} />
                                    </div>
                                </PopoverTrigger>
                                <PopoverSurface style={{ padding: 10 }}>
                                    <Input
                                        placeholder={"Find person"}
                                        appearance="underline"
                                        size="small"
                                        value={userSearchText}
                                        onChange={onChangeUserSearch}
                                        style={{ width: "100%" }}
                                    />
                                    {filteredUsers.map((user, index) => (
                                        // <>
                                        <div className="currentBookingUsercontainer" onClick={() => { onAddAttendee(user) }}>
                                            <div className="avatar">
                                                <Avatar
                                                    name={`${user.FirstName} ${user.LastName}`}
                                                    image={{
                                                        src: user.UserImage,
                                                    }}
                                                    style={{
                                                        cursor: "pointer", width: "30px", height: "30px"
                                                    }}
                                                    shape="circular"
                                                />
                                            </div>
                                            <div className="name">
                                                <span style={{ fontSize: 13, fontWeight: 400, fontStyle: "normal" }}>{`${user.FirstName} ${user.LastName}`}</span>
                                            </div>
                                            <div className="icContainer">
                                                <div style={{ width: "22px", height: "22px" }}>
                                                    {user.WorkPlace && user.WorkPlace.IconPath !== "" && (<img src={`${CommonInfo.folderName}${user.WorkPlace.IconPath}`} />)}
                                                </div>
                                            </div>
                                        </div>
                                        // </>
                                    ))}
                                </PopoverSurface>
                            </Popover>
                        </>
                    </div>
                </div>
                <div className={styles.extendableContainer} style={{ padding: "10px 10px 0px 10px" }}>
                    <img src={`${CommonInfo.folderName}${theme === 'dark' ? '/maplight.svg' : '/map.svg'}`} className={styles.formIcon} />
                    <div className={styles.extendListConatiner}>
                        {addedResources.map((resource, index) => (
                            <ResourceModel
                                key={index}
                                theme={theme}
                                resource={resource.resource}
                                isAvailable={resource.availablity}
                                conflictCount={resource.unavailableDateTime ? `${resource.unavailableDateTime.length}` : ""}
                                onRemove={() => removeResource(index)}
                                onConflictAction={() => onConflictClick(index)}
                                isConflictShown={conflictViewShown}
                            />
                        ))}
                        {/* <div className={styles.addAttendeeContainer} onClick={onAddWorkspacesAction}>
                            <span style={{ fontSize: 13, fontWeight: 400, fontStyle: "normal" }}>Add workspace</span>
                            <IoMdAddCircleOutline size={18} />
                        </div> */}
                    </div>
                </div>

            </div>
            <div className={styles.actionContainer}>
                <Button shape="circular" onClick={onClickClose} style={{ width: 'fit-content', height: 'fit-content', paddingLeft: 15, paddingTop: 7, paddingRight: 15, paddingBottom: 7 }}>
                    {t('Close')}
                </Button>

                <Button
                    shape="circular"
                    // icon={<FaSave size={20} />}
                    // iconPosition="before"
                    className="bg-success"
                    onClick={onSaveAction}
                    style={{ width: 'fit-content', height: 'fit-content', paddingLeft: 15, paddingTop: 7, paddingRight: 15, paddingBottom: 7 }}
                >
                    {t('Book')}
                </Button>
            </div>
        </div>
    );
};

export default ResourceSpaceBooking;